var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M0 0 L10 10 L20 0","fill":"transparent","stroke":"#676767","strokeLinecap":"round","strokeLinejoin":"rount","strokeWidth":"3"})));
}

Arrow.defaultProps = {"role":"img"};

module.exports = Arrow;

Arrow.default = Arrow;
